/**
 * @pageName BlogTags
 * @slotType dashboard plugin
 */
export type TagsBannerParams = EmptyParams;

/** @internal */
export type EmptyParams = {};

/**
 * @pageName BlogTags
 * @slotType dashboard menu plugin
 */
export type TagItemMoreActionsMenuParams = ActionParams;

// These are used in the dev center, do not delete them
/** @internal */
export type ActionParams = {
  // ID of the selected item.
  selectedId: string;
};

/**
 * @pageName BlogTags
 * @slotType dashboard menu plugin
 */
export type TagItemsBulkMoreActionsMenuParams = BulkActionParams;

/** @internal */
export type BulkActionParams = {
  // ID of the selected items.
  selectedIds: string[];
};
